import styled from "styled-components";
import { MdExpandMore } from "react-icons/md";


export const PricingTabSection = styled.div`
    border: 1px solid #c5c5c5;
    width: 100%;
    padding: 10px 12px;
    border-radius: 4px;
    background: #fff;
    margin-bottom:20px;
    @media(max-width:1199px){
        width: 100%;
        button{
        margin-left:0;
        margin-top:20px;
        }
    }
`
export const Container = styled.div`
    height: auto;
    display: grid;
    grid-template-columns: 25% 75%;
    width:100%;
    justify-content: space-around;
}
`
export const CardContainer = styled.div`
 border:2px solid #f2f2f2;
 border-radius: 10px;
 width:90%;
 min-height: 55px;
 height: auto;
 text-align: center;
 font-weight: 500;
 margin-bottom:  10px;
`
export const CMdExpandMore = styled(MdExpandMore)`
    margin: 10px;
    margin: 15px 10px 10px 10px;

`
export const CardTitle = styled.div`
float: left;
margin: 15px 10px 10px 25px;
`

export const MedicalCard = styled.div`
border:1px solid #f2f2f2;
width: 100%;
height: auto;
margin: auto;
border-radius:10px;
overflow:auto;
background-color:white;
`
export const MedicalSearch = styled.div`
 padding:15px 25px 15px 25px;
 width: 100%;
 grid-template-columns: 17% 63% 20%;
 justify-content: space-between;
 p{
    margin:0;
 }
 .MuiFormControl-root{
    margin-top:0px !important;
    width:100%;
    .MuiInputBase-root{
        width:100%;
    }
    .MuiInput-underline:before,
    .MuiInput-underline:after{
        content:none !important;
    }
 }
    @media(max-width:1199px){
         padding:15px 15px;
         --bs-gutter-x:0;
         align-items: center;
         button {
            margin-top:0;
         }
    }
`
export const MedicalTab = styled.div`
display: flex;
align-items: center;
background-color: #4678eb;
height: 35px;
width: 100%;
color: white;
font-weight: 600;
font-size:12px;
padding-left:27px;
font-weight:600;
font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
`
export const Table = styled.table`
    font-size: 14px;
    width: 100%;
    overflow:auto;
    th{
        font-size:12px;
        text-align: left;
        padding-top:15px;
        padding-left:27px;
        font-weight:600;
        color:#58595B;
font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    }
    td{
        text-align: left;
        color:grey;
        font-size:12px;
        font-weight:500;
        font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
        padding-top:15px;
        color:#969696;
        padding-left:27px;
    }
`

export const PurpleText = styled.h4`
    font-size:15px;
    font-weight:600;
    color:#4678ED;
    font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    margin-bottom:0px;
    margin-top:10px
`
export const PricingTable = styled.table`
    font-size:12.85px;
    font-weight:600;
    color:#606060;
    width:100%;
    font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    th, td {
        font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    }
    .purpleText{
        color:#4678ED;
    }
    .pendingText{
        color:#FF1D25;
    }
    .greenText{
        color:#008576;
    }
`

export const ImageDollor = styled("img")`
    width: 46px;
    object-fit: contain;
    margin-top: 0px;
    transform: rotateZ(25deg);  
`;
export const ImageDollorRotate = styled("img")`
    width: 46px;
    object-fit: contain;
    margin-top: 0px;
    transform: rotateZ(25deg);  
`;
export const PriceEndCostText = styled.div`
    width: 100%;
    color:#fff;
    background-color:#15BEEE;
    font-size:18px;
    font-weight:bold;
    font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    padding: 5px 12px;
    border-radius:4px;
`;
export const PopupHeading = styled.div`
    padding: 22px 20px;
    border-bottom:1px solid #CCCCCC;
    position: relative;
    h2{
        font-size:19.4px;
        color:#4678ED;
        font-weight:600;
        margin-bottom:0;
        font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    }
    button{
        border: none;
        font-weight: 400;
        background: transparent;
        text-transform: lowercase;
        font-size: 28px;
        position: absolute;
        top: 9px;
        padding: 0 10px;
        right: 20px;
        color: #58595B;
    }
`;
export const PopupBody = styled.div`
    padding: 22px 20px;
    font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    h2{
        font-size:19.4px;
        color:#4678ED;
        font-weight:600;
        margin-bottom:0;
        font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    }
    h5{
        font-size:17px;
        color:#58595B;
        font-weight:600;
        margin-bottom:10px;
        font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    }
    p{
        font-size:15px;
        color:#58595B;
        font-weight:400;
        margin-bottom:10px;
        font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    }
    a{
        font-size:15px;
        color:#0071BC;
        font-weight:400;
        margin-bottom:10px;
        text-decoration:underline;
        font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    }
`;

export const ButtonBody = styled.div`
    margin:0 0 20px;
    align-items: center;
    .printButton{
        border:none;
        background:transparent;
        font-size:15px;
        color:#0071BC;
        text-decoration:underline;
        font-family: work sans, 'Open Sans', Helvetica, Arial, sans-serif;
    }
    .text-right{
        text-align: right;
    }
`
export const ADHImage = styled.img`
width:130px;
height:500px;
@media (max-width:1416px){
    width:130px;
  }
@media (max-width:1116px){
  width:110px;
}
@media (max-width:766px){
  width:90px;
}
@media (max-width:640px){
  width:85px;
}
`